// Scheduling is explicit: conversation text, history, files and memory cannot
// open setup. The command only creates an editable draft, never a schedule.
export function scheduledTaskDraft(text) {
  if (typeof text !== 'string' || text.length > 4000 || !/^\/schedule(?:\s|$)/i.test(text.trim())) return null;
  const instructions = text.trim().replace(/^\/schedule\s*/i, '').trim();
  return {
    name: instructions.replace(/[?.!]+$/, '').slice(0, 80), instructions,
    scheduleType: 'daily', scheduleTimeOfDay: '', scheduleDayOfWeek: '',
    scheduleDayOfMonth: '', scheduleRunAt: '',
    emailDeliveryEnabled: false, emailDeliveryTiming: 'immediate',
  };
}
